import { Injectable, signal, TemplateRef } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class LoadingService {
    loading = signal(false);
    private blocking: boolean;
    private loadingTemplateSubject: BehaviorSubject<TemplateRef<any>>;
    defaultTemplateRef: TemplateRef<any>;
    loadingTemplate$: Observable<TemplateRef<any>>;

    constructor() {}

    getTemplate(): Observable<TemplateRef<any>> {
        return this.loadingTemplateSubject.asObservable();
    }

    setDefaultTemplate(newValue: TemplateRef<any>): void {
        this.defaultTemplateRef = newValue;

        if (this.loadingTemplateSubject == null) {
            this.loadingTemplateSubject = new BehaviorSubject<TemplateRef<any>>(this.defaultTemplateRef);
            this.loadingTemplate$ = this.loadingTemplateSubject.asObservable();
        }

        this.loadingTemplateSubject.next(this.defaultTemplateRef);
    }

    setTemplate(newValue: TemplateRef<any>): void {
        this.loadingTemplateSubject.next(newValue);
    }

    resetTemplate() {
        this.loadingTemplateSubject.next(this.defaultTemplateRef);
    }

    getLoadingStatus(): boolean {
        return this.loading();
    }

    setLoadingStatus(newValue: boolean): void {
        this.loading.set(newValue);
    }

    showLoading(): void {
        this.blocking = true;
        this.loading.set(true);
    }

    hideLoading(): void {
        this.loading.set(false);
        this.blocking = false;
    }

    getBlockingStatus(): boolean {
        return this.blocking;
    }
}
